import Axios, { AxiosError, AxiosRequestConfig } from 'axios';
import { AuthContext } from 'context/auth';

import _ from 'lodash';
import { useContext } from 'react';
import { openNotification } from '../commons/Notifications';
import { checkTokenExpired } from '../utils/helpers/auth_helpers';


//import { setupCache } from 'axios-cache-adapter';

const LOCAL_DEBUG = true;

// Set MAIN_URL api
export const MAIN_URL: any = () => {
  //@ts-ignore
  const url = process?.env?.REACT_APP_API_URL || undefined;

  return url;
};

console.info('MAIN_URL', MAIN_URL());
if (!MAIN_URL()) {
  alert('No API_URL FOUND!');
}
const API_VERBOSE = true;
const API_DEBUG = false;
export interface ApiResponse {
  data: any[];
  status?: number;
  success: boolean;
  pagination?: ResponsePagination;
}

export interface ResponsePagination {
  page: number;
  pageCount: number;
  pageSize: number;
  total: number;
}

interface ServerError {
  name: any;
  title?: string;
  message: any;
  code: number;
  status: number;
  errors?: string | any[];
  error?: string;
  type: string;
  hideError?: boolean;
}
// Create `axios-cache-adapter` instance
// const AXIOS_CACHE = setupCache({
//   maxAge: 3000, // 15 * 60 * 1000, //15 minuti
//   //debug: true,
//   ignoreCache: true,
//   // exclude: {
//   //   // {Array} List of regular expressions to match against request URLs.
//   //   paths: [],
//   // },
// });

const default_config = (): IApiCall => ({
  method: 'GET',
  baseURL: MAIN_URL(),
  timeout: LOCAL_DEBUG ? 3 * 60 * 1000 : 20 * 1000,
  headers: {
    'Content-Type': 'application/json',
    //'Cache-Control': 'public',
    // 'Cookie': 'XDEBUG_SESSION=PHPSTORM'
  },
  // withCredentials: true,
  responseType: 'json',
  maxRedirects: 1,
  validateStatus(status) {
    return status < 400; // Reject only if the status code is greater than or equal to 400
  },
  //adapter: AXIOS_CACHE.adapter,
});
export const API = Axios.create(default_config());

// Add a request interceptor
API.interceptors.request.use(
  async (config: IApiCall) => {
    // Do something before request is sent

    // XDEBUG_SESSION_START DEBUGGER
    if (LOCAL_DEBUG) {
      if (config.params) {
        config.params.XDEBUG_SESSION_START = 1;
      } else {
        config.params = {
          XDEBUG_SESSION_START: 1,
        };
      }
    }

    return config;
  },
  (error) => {
    // Do something with request error
    return Promise.reject(error);
  }
);

// Add a response interceptor
API.interceptors.response.use(
  (response: any) => {
    // Do something with response data
    if (response.status >= 400 || response.success === false) {
      if (API_DEBUG) {
        //debugger;
      }
      return Promise.reject(response.data);
    } else {
      let pagination: ResponsePagination | any = null;
      if (response.config.params && response.config.params.pagination) {
        const {
          'x-pagination-current-page': page = 1,
          'x-pagination-page-count': pageCount = 0,
          'x-pagination-per-page': pageSize = 20,
          'x-pagination-total-count': total = 0,
        } = response.headers;
        pagination = { page, pageCount, pageSize, total };

        //console.log("pagination", pagination)
      }

      const returnData: any = {
        data:
          _.get(response, 'data.data.list') ||
          _.get(response, 'data.data') ||
          _.get(response, 'data'),
        pagination,
        success: true,
      };
      return Promise.resolve(returnData);
    }
  },
  (error: AxiosError) => {
    // Do something with response error
    if (API_DEBUG) {
      //debugger;
    }
    showErrorMessage(error);

    return Promise.reject(error?.response?.data || 'Generic Error');
  }
);

interface IApiCall extends AxiosRequestConfig {
  hasUpload?: boolean;
}
export const API_CALL = async (config: IApiCall) => {
  checkTokenExpired();

  const axiosConfig = _.merge(default_config(), config);
  if (API_DEBUG) {
    //debugger;
  }
  if (axiosConfig.params) {
    axiosConfig.params = formatParams(axiosConfig.params);
  }

  if (axiosConfig.hasUpload || axiosConfig?.data?.file_upload) {
    axiosConfig.headers!['Content-Type'] = 'multipart/form-data';
    if (axiosConfig.data) {
      axiosConfig.data = jsonToFormData(axiosConfig.data);
    }
  }
  //   if (axiosConfig?.hasUpload === false) {
  //     axiosConfig.headers['Content-Type'] = 'application/json';
  //   }

  let authToken = localStorage.getItem('token');

  if (authToken) {
    axiosConfig.headers!.Authorization = `Bearer ${authToken}`;
  }

  const urlCalled = `${axiosConfig.baseURL} ${axiosConfig.url}`;
  API_VERBOSE &&
    console.info(
      'API_CALL',
      `${axiosConfig.method} => ${urlCalled}`,
      axiosConfig.params || axiosConfig.data
    );
  // console.info('axiosConfig', axiosConfig)

  return API(axiosConfig)
    .then((responseData: any) => {
      API_VERBOSE && console.info('API_SUCCESS => ' + urlCalled, responseData.data || responseData);

      if (API_DEBUG) {
        //debugger;
      }
      if (responseData.pagination) {
        return responseData;
      } else {
        return responseData.data ?? responseData;
      }
    })
    .catch((err) => {
      console.warn('ERROR', err);
      if (API_DEBUG) {
        //debugger;
      }
      return Promise.reject(err);
    });
};

const showErrorMessage = (error: AxiosError) => {
  if (API_DEBUG) debugger;

  const errorResponse: ServerError =
    error?.response?.data?.data || error?.response?.data || error?.response || error;

  let errorMessage = unescape(
    `${errorResponse?.message ||
    errorResponse?.errors ||
    errorResponse?.error ||
    errorResponse?.code ||
    errorResponse?.type
    }`
  );

  if (errorResponse.name && errorResponse.name === 'Unauthorized') {
    //debugger;
    if (checkTokenExpired()) {
      openNotification({ message: 'Sessione Scaduta!', type: 'error' });
      setTimeout(function () {
        window.location.reload();
      }, 2000);
    } else {
      openNotification({ message: errorMessage || 'Utente non autorizzato', type: 'error' });
    }
  } else if (errorResponse.name && errorResponse.name === 'multiple_error') {
    if (_.isArray(errorResponse.errors) || _.isObject(errorResponse.errors)) {
      errorMessage = '';
      _.map(errorResponse.errors, (error, field) => {
        errorMessage += `${field} : ${error}
			`;
      });
    }
  } else if (_.isArray(errorResponse)) {
    errorMessage = '';
    _.map(errorResponse?.errors || errorResponse, ({ message, field }, index) => {
      errorMessage += `${field} : ${message}
			`;
    });
  } else {
    errorMessage = unescape(
      `${(errorResponse.message) ||
      errorResponse.errors ||
      errorResponse.error ||
      errorResponse.code ||
      errorResponse.type
      }`
    );
  }

  const { url, method, params, data, headers } = error.config;
  const jsonError = {
    payload: { url: url!.replace(MAIN_URL(), ''), method, headers, params, data },
    response: errorResponse,
  };
  if (API_DEBUG) debugger;
  if (errorResponse.hideError) return;

  showErrorNotification(errorMessage, jsonError);
};

export const showErrorNotification = (errorMessage: string, jsonError: any = {}) => {
  openNotification({
    //message: unescape(`${errorResponse.title || errorResponse.name || 'Errore '}`),
    message: 'Errore',
    type: 'error',
    duration: 10,
    style: {
      width: 600,
      marginLeft: 335 - 600,
    },
    description: (
      <div>
        {unescape(errorMessage || '')}
        {/* <JsonLog json={jsonError} title="Error Data" collapsed={0} /> */}
      </div>
    ),
  });
};
const formatParams = (params: any) => {
  //console.info('formatParams', params);

  //params = _.pickBy(params, _.identity)
  params = _.pickBy(params, (v) => v !== null && v !== undefined && v !== '');
  if (params.pagination) {
    // page: 1,
    //   count : 0,
    //     perPage : 20,
    //       total : 0
  }
  return params;
};
export default API_CALL;

const buildFormData = (formData, data, parentKey = '') => {
  if (data && typeof data === 'object' && !(data instanceof Date) && !(data instanceof File)) {
    Object.keys(data).forEach((key) => {
      buildFormData(formData, data[key], parentKey ? `${parentKey}[${key}]` : key);
    });
  } else {
    const value = data == null ? '' : data;

    formData.append(parentKey, value);
  }
};

export const jsonToFormData = (data: any) => {
  const formData = new FormData();

  buildFormData(formData, data);

  return formData;
};
